import { parseODataFilter } from "@sg-protect/core";
import type { EditableExpression } from "../expressions/base/types.ts";
import { extractEditableExpressions } from "./extractEditableExpressions.ts";

export function getFilterField(expression: EditableExpression): string | null {
    switch (expression.type) {
        case "comparison":
            return expression.left.toPathString();
        case "function":
        case "in":
            return expression.property.toPathString();
        case "lambda":
            return expression.toPathString();
        default:
            return null;
    }
}

function getFilterFields(expression: EditableExpression): string[] {
    if (expression.type === "not") {
        return extractEditableExpressions(expression.inner).flatMap(getFilterFields);
    }

    const field = getFilterField(expression);

    return field === null ? [] : [field];
}

export function getFilteredFields(filter?: string): string[] {
    try {
        return [...new Set(extractEditableExpressions(parseODataFilter(filter)).flatMap(getFilterFields))];
    } catch {
        // Telemetry never breaks the page: a filter the parser refuses names no field.
        return [];
    }
}
